import React from 'react';
import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

interface ICalendarInputProps {
  label: string;
  hideLabel?: boolean;
  nameId: string;
}

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & ICalendarInputProps;

export const CalendarInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <>
    <div className="form-group">
      <label htmlFor={props.nameId} className={props.hideLabel ? "form-label sr-only" : ""}>
        <FormattedMessage id={props.label ? props.label : 'calendar.select.month'}/>
      </label>
      <div className="input-group" id={props.id}>
        <input className="form-control datepicker" style={ props.disabled ? { cursor: 'default' } : undefined } 
          name={props.nameId} id={props.nameId} value={props.value}
          disabled={props.disabled} 
          autoComplete="off" 
          readOnly
          ref={ref}
          onChange={props.onChange}
          onClick={props.onClick}
        />
        <button disabled={props.disabled} className="ui-datepicker-trigger" 
                onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => 
                  { if(props.onClick) props.onClick(e as (React.MouseEvent<HTMLInputElement, MouseEvent>)) } }>
          <span className='sr-only'><FormattedMessage id="button.open.calendar"/></span>
        </button>
      </div>
    </div>
   </>
));

export default CalendarInput;